module.exports = __webpack_public_path__ + "static/img/5138_phase_function_Paper_Points.22a8c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5138_phase_function_Paper_Points.png
// module id = HXh8
// module chunks = 0